import field from '../messages/field/de'
import format from '../messages/format/de'
import navigation from '../messages/navigation/de'
import parser from '../messages/parser/de'

export default {
  navigation,
  parser,
  field,
  format
}